import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Player from '../../common/Player';
import { getMovieByUrl } from '../../api';
import ResponsiveContainer from '../../common/ResponsiveContainer';
import './Movie.css';

const Movie = () => {
  const [movieData, setMovieData] = useState(null);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState({
    controls: true,
    autoplay: false,
    sources: null,
    techOrder: ['chromecast', 'html5'],
    poster: '',
    updated: false,
  });

  const onPlayerReady = (_player) => {};

  const { movie } = useParams();
  useEffect(() => {
    getMovieByUrl(movie)
      .then((res) => {
        setMovieData(res.data);
        const poster = res.data.url?.replace('turkish4love.com/videos/', 'turkish4love.com/thumbnails/').replace('.mp4', '.jpeg') || '';
        setOptions((prev) => ({ ...prev, sources: { src: res.data.url_video }, poster, updated: true }));
      })
      .catch((err) => {
        setError(err?.response?.status === 403 ? 'forbidden' : 'error');
      });
  }, []);

  if (error) {
    return (
      <ResponsiveContainer className='pt-5 pb-4'>
        <div className='flex flex-col items-center justify-center min-h-[60vh] text-center gap-4'>
          <p className='text-5xl'>🔒</p>
          <h2 className='font-montserrat font-bold text-xl text-gray-800'>
            {error === 'forbidden' ? 'No tienes acceso a este contenido' : 'Error al cargar el contenido'}
          </h2>
          <p className='font-montserrat text-gray-500 text-sm'>
            {error === 'forbidden'
              ? 'Tu cuenta no tiene permisos para ver esta película.'
              : 'Ocurrió un error inesperado. Intenta de nuevo más tarde.'}
          </p>
        </div>
      </ResponsiveContainer>
    );
  }

  return (
    <ResponsiveContainer className='pt-5 pb-4'>
      {/* Header */}
      <div className='flex items-center justify-between bg-white rounded-lg shadow px-5 py-3 mb-3 mt-4'>
        <div>
          {movieData ? (
            <>
              <h1 className='text-red-1 font-bold font-montserrat text-xl leading-tight'>{movieData.titulo_original}</h1>
              <p className='text-gray-400 text-xs font-montserrat uppercase tracking-wider mt-0.5'>Película</p>
            </>
          ) : (
            <>
              <div className='h-5 w-48 bg-gray-200 animate-pulse rounded mb-1' />
              <div className='h-3 w-16 bg-gray-100 animate-pulse rounded' />
            </>
          )}
        </div>
        <Link
          to='/peliculas'
          className='flex items-center gap-2 bg-red-1 hover:bg-darkred text-white text-sm font-montserrat font-semibold px-4 py-2 rounded-lg transition-colors flex-shrink-0'
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          <span>Volver</span>
        </Link>
      </div>

      {/* Player */}
      <div className='bg-black rounded-lg overflow-hidden shadow'>
        {options.sources ? (
          <Player options={options} onReady={onPlayerReady} />
        ) : (
          <div className='w-full aspect-video bg-gray-200 animate-pulse' />
        )}
      </div>

      {/* Movie info */}
      {movieData ? (
        <div className='bg-white rounded-lg shadow p-5 mt-3'>
          <div className='flex flex-wrap gap-2 mb-3'>
            {movieData.generos?.map((genero, index) => (
              <span key={index} className='bg-red-1 text-white text-xs font-montserrat font-semibold px-3 py-1 rounded-full'>
                {genero}
              </span>
            ))}
            {movieData.estado && (
              <span className='bg-gray-100 text-gray-500 text-xs font-montserrat px-3 py-1 rounded-full'>
                {movieData.estado}
              </span>
            )}
          </div>
          <p className='text-gray-600 text-sm font-montserrat leading-relaxed'>{movieData.descripcion}</p>
        </div>
      ) : (
        <div className='bg-white rounded-lg shadow p-5 mt-3'>
          <div className='flex gap-2 mb-3'>
            <div className='h-6 w-16 bg-gray-200 animate-pulse rounded-full' />
            <div className='h-6 w-20 bg-gray-100 animate-pulse rounded-full' />
          </div>
          <div className='flex flex-col gap-2'>
            <div className='h-4 w-full bg-gray-100 animate-pulse rounded' />
            <div className='h-4 w-4/5 bg-gray-100 animate-pulse rounded' />
            <div className='h-4 w-3/4 bg-gray-100 animate-pulse rounded' />
          </div>
        </div>
      )}
    </ResponsiveContainer>
  );
};

export default Movie;
